import React, { useState, useRef, useEffect } from "react";

const NotificationDropdown = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !event.target.closest('.notification-button')
    ) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="notification-button p-2 text-gray-400 hover:text-gray-500 relative"
      >
        <i className="fas fa-bell text-xl" />
        <span className="absolute top-1 right-1 h-2 w-2 bg-black rounded-full" />
      </button>
      {isDropdownVisible && (
        <div
          ref={dropdownRef}
          className="absolute top-10 right-0 z-50 w-64 bg-white border border-gray-200 rounded-lg shadow-lg"
        >
          <div className="p-4 text-sm text-gray-700 font-medium border-b">
            Notifications
          </div>
          <ul
            className="divide-y divide-gray-200 max-h-48 overflow-y-auto"
            style={{ scrollbarWidth: "thin", scrollbarColor: "#c1c1c1 #f1f1f1" }}
          >
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">Submission reviewed: Paul Demenko</p>
              <span className="text-xs text-gray-500">37 minutes ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">39 minutes ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">5 days ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">5 days ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">5 days ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">5 days ago</span>
            </li>
            <li className="p-4 hover:bg-gray-50 cursor-pointer">
              <p className="text-sm">New submission received: Paul Demenko</p>
              <span className="text-xs text-gray-500">5 days ago</span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
